import { render } from "./CustomersPage.vue?vue&type=template&id=50063a0e&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"

import "./CustomersPage.vue?vue&type=style&index=0&id=50063a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50063a0e"]])

export default __exports__